import React from 'react'
import PropTypes from 'prop-types'
import CloseIcon from 'react-icons/lib/md/close'

import IconButton from 'app/domains/common/IconButton'
import './styles.scss'
const bc = 'header-notification-common'

const HeaderNotification = ({ t, setTopNotificationBlockShown, children, additionalClosingAction }) => (
  <div className={bc}>
    <span className={`${bc}__new-feature`}>{t('New Feature')}</span>
    {children}
    <IconButton
      className={`${bc}__close`}
      onClick={() => {
        setTopNotificationBlockShown(false)
        additionalClosingAction && additionalClosingAction()
      }}
    >
      <CloseIcon />
    </IconButton>
  </div>
)

HeaderNotification.propTypes = {
  setTopNotificationBlockShown: PropTypes.func.isRequired,
  additionalClosingAction: PropTypes.func,
}

export default HeaderNotification
